import { makeStyles } from '@mui/styles';

export const styles = makeStyles((theme) => ({
  toolbar: {
    minHeight: '20px',
    height: '20px',
  },
}));
